<template>
  <div class="address-view" :class="{disabled}" @click.stop>
    <i class="icon-view el-icon-arrow-up" v-if="showSelect" />
    <i class="icon-view el-icon-circle-close" v-else-if="value.areaId || value.cityId" @click="handleClear" />
    <i class="icon-view el-icon-arrow-down" v-else @click="handleInit" />
    <el-input class="input-view" type="text" v-model="inputText" @input="handleInput" @focus="handleInit" ref="input" :disabled="disabled" />
    <div class="select-view" v-if="showSelect">
      <div class="scroll-view">
        <div class="sv-item" v-for="item in showList" :key="item.code" @click="handleClick(item)">{{item.nativeName}}</div>
        <div v-if="loading && showList.length === 0">{{$lang('加载中...')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqAddressList } from './pool'
export default {
  data() {
    return {
      loading: false,
      inputText: '',
      filterText: '',
      data: { ...this.value },
      provinceList: [],
      childrenList: [],
      showSelect: false
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: Boolean
  },
  created() {
    this.setInput()
  },
  computed: {
    showList() {
      const { provinceId, cityId } = this.data
      let list = this.provinceList
      if (provinceId || cityId) {
        list = this.childrenList
      }
      return list.filter(o => !this.filterText || o.nativeName.match(this.filterText))
    }
  },
  watch: {
    data: {
      deep: true,
      handler({ provinceId: pid, cityId: cid, areaId: aid }) {
        if (pid && cid && aid) {
          this.windowClick()
        } else if (pid && cid && !aid) {
          this.getList(cid)
        } else if (pid && !cid) {
          this.getList(pid)
        }
      }
    },
    value: {
      deep: true,
      handler(data) {
        const { provinceId: pid, cityId: cid, areaId: aid } = data
        const { provinceId: p, cityId: c, areaId: a } = this.data
        if (p !== pid || c !== cid || a !== aid) {
          this.data = { ...data }
          this.setInput()
        }
      }
    }
  },
  methods: {
    async getList(code) {
      this.loading = true
      await reqAddressList(code)
        .then(({ data }) => {
          if (data && data.records) {
            this.childrenList = data.records
            if (code === '1') {
              this.provinceList = data.records
            }
          }
        })
        .catch(() => { })
      this.loading = false
    },
    handleInit() {
      if (!this.provinceList.length) {
        this.getList('1')
      }
      if (this.disabled) {
        return
      }
      if (this.data.areaId) {
        this.data = {}
      }
      setTimeout(() => {
        this.filterText = ''
        this.showSelect = true
        this.setInput()
        document.body.addEventListener('click', this.windowClick)
      }, 100)
    },
    handleClear() {
      if (this.disabled) {
        return
      }
      const data = {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: ''
      }
      this.$emit('input', data)
      this.$emit('changeValue', data)
    },
    windowClick() {
      this.showSelect = false
      if (!this.data.areaId) {
        this.data = { ...this.value }
        this.setInput()
      }
      if (this.data.areaId !== this.value.areaId) {
        const data = { ...this.data }
        this.$emit('input', data)
        this.$emit('changeValue', data)
      }
      document.body.removeEventListener('click', this.windowClick)
    },
    handleInput(val) {
      const items = val.replace(/\s/g, '').split('/')
      this.filterText = items[items.length - 1]
      const text = this.setInput(true)
      if (val.indexOf(text) === -1) {
        this.filterText = ''
        if (this.data.cityId) {
          const { provinceId, provinceName } = this.data
          this.data = { provinceId, provinceName }
          this.childrenList = []
        } else if (this.data.provinceId) {
          this.data = {}
        }
        this.setInput()
      }
    },
    handleClick(item) {
      this.filterText = ''
      this.childrenList = []
      const { provinceId, cityId, areaId } = this.data
      if (!provinceId) {
        this.$set(this.data, 'provinceId', item.id)
        this.$set(this.data, 'provinceName', item.nativeName)
        this.$refs.input.focus()
      } else if (!cityId) {
        this.$set(this.data, 'cityId', item.id)
        this.$set(this.data, 'cityName', item.nativeName)
        this.$refs.input.focus()
      } else if (!areaId) {
        this.$set(this.data, 'areaId', item.id)
        this.$set(this.data, 'areaName', item.nativeName)
      }
      this.setInput()
    },
    setInput(getStr) {
      const { provinceName, cityName, areaName } = this.data
      let text = ''
      if (provinceName) {
        text += provinceName + ' / '
      }
      if (cityName) {
        text += cityName + ' / '
      }
      if (areaName) {
        text += areaName + ' / '
      }
      if (getStr) {
        return text
      } else {
        this.inputText = text
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address-view {
  position: relative;
  font-size: 12px;
  line-height: 0;
  &.disabled {
    cursor: no-drop;
  }
}
.icon-view {
  position: absolute;
  right: 3px;
  top: 50%;
  margin-top: -8px;
  z-index: 10;
  font-size: 16px;
  color: #999;
}
.el-input.input-view {
  width: 100%;
  input {
    padding-right: 30px;
  }
}
.select-view {
  position: absolute;
  color: #999;
  top: 25px;
  z-index: 12;
  // background-color: #fff;
  @include bg-color('pop');
  width: 100%;
  box-sizing: border-box;
  // padding-left: 10px;
  line-height: 30px;
  border: 1px solid #ddd;
  @include border-color('lighter');
  .scroll-view {
    height: 300px;
    overflow-y: auto;
  }
  .sv-item {
    padding-left: 10px;
    &:hover {
      @include bg-color('pop-active');
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss" >
.address-view {
  .el-input.input-view {
    input {
      padding-right: 20px;
    }
  }
}
</style>
